module.exports = __webpack_public_path__ + "img/wrapbg7.8c2ad273.png";